import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import Dashboard from "scenes/dashboard";
import Settings from "scenes/settings"
import Login from "pages/Login";
import Register from "pages/Register";
import Unauthorized from "pages/Unauthorized.jsx"
import PrivateRoute from "./components/PrivateRoute.jsx";
import ResultsPage from "./components/ResultsPage.jsx";
import DealDetails from "./components/DealDetails.jsx";
import { useDispatch } from 'react-redux';
import { login } from './redux/authSlice.js';
import { setUser } from './state/index.js'
import SalesHub from "scenes/sales";
import Contacts from "scenes/sales/Contacts.jsx"
import Companies from "scenes/sales/Companies.jsx"
import Activities from "scenes/sales/Activities.jsx"
import Deals from "scenes/sales/Deals.jsx"
import FinanceHub from "scenes/finance";
import AppsHub from "scenes/apps";
import DataHub from "scenes/data";
import ContentHub from "scenes/content";
import Loyalty from "scenes/loyalty";
import HRHub from "scenes/hr";
import DevHub from "scenes/dev";
import LegalHub from "scenes/legal";
import About from "scenes/about";
import Replier from "scenes/replier";
import ChatBox from "scenes/chat";
import CalendarPage from "scenes/calendar";
import ContractForm from "scenes/hr/contractGen/contractGen.jsx"

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

useEffect(() => {
    const fetchUserAndSetState = async () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const user = JSON.parse(storedUser);
        dispatch(login({ user }));
        dispatch(setUser(user));
      }
      setLoading(false);
    };

    fetchUserAndSetState();
  }, [dispatch]);


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/sales" element={<PrivateRoute><SalesHub /></PrivateRoute>} />
              <Route path="/sales/contacts" element={<PrivateRoute><Contacts /></PrivateRoute>} />
              <Route path="/sales/activities" element={<PrivateRoute><Activities /></PrivateRoute>} />
              <Route path="/sales/companies" element={<PrivateRoute><Companies /></PrivateRoute>} />
              <Route path="/sales/deals" element={<PrivateRoute><Deals /></PrivateRoute>} />
              <Route path="/apps" element={<PrivateRoute><AppsHub /></PrivateRoute>} />
              <Route path="/finance" element={<PrivateRoute><FinanceHub /></PrivateRoute>} />
              <Route path="/data" element={<PrivateRoute><DataHub /></PrivateRoute>} />
              <Route path="/content" element={<PrivateRoute><ContentHub /></PrivateRoute>} />
              <Route path="/loyalty" element={<PrivateRoute><Loyalty /></PrivateRoute>} />
              <Route path="/hr" element={<PrivateRoute><HRHub /></PrivateRoute>} />
              <Route path="/dev" element={<PrivateRoute><DevHub /></PrivateRoute>} />
              <Route path="/legal" element={<PrivateRoute><LegalHub /></PrivateRoute>} />
              <Route path="/about" element={<PrivateRoute><About /></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
              <Route path="/chat" element={<PrivateRoute><ChatBox /></PrivateRoute>} />
              <Route path="/calendar" element={<PrivateRoute><CalendarPage /></PrivateRoute>} />
              <Route path="/contractGen" element={<PrivateRoute><ContractForm /></PrivateRoute>} />
              <Route path="/results" element={<PrivateRoute><ResultsPage /></PrivateRoute>} />
              <Route path="/deal-details" element={<PrivateRoute><DealDetails /></PrivateRoute>} />
              <Route path="/replier" element={<PrivateRoute><Replier /></PrivateRoute>} />
              <Route path="/unauthorized" element={<Unauthorized />} />
            </Route>
            </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
